import { COLUMN_CONTROLLER, COLUMN_ENTRY_READER, COLUMN_EXIT_READER, COLUMN_NAME, COLUMN_SITE, COLUMN_ZONES_COUNT } from "../../constants/column-types";
import { FILTER_CONTROLLER, FILTER_SITES, FILTER_ZONES } from "../../constants/filter-types";
import { TableColumn } from "../table/TableColumn";

const DoorColumns: TableColumn[] = [
    {
        heading: "Name",
        accessor: "name",
        isNumeric: false,
        id: 0,
        active: true,
        sortByName: "locName",
        sortDirection: "asc",
        translationKey: "name",
        isDefault: true,
        columnId: COLUMN_NAME,
    },
    {
        heading: "Zones",
        accessor: "zone",
        isNumeric: false,
        id: 1,
        sortByName: "zoneByZoneId.zoneName",
        sortDirection: "asc",
        active: true,
        searchOnName: "zoneByZoneId.id",
        lookupName: "zoneByZoneId.zoneName",
        translationKey: "zone",
        columnId: COLUMN_ZONES_COUNT,
        settingDataName: "zone",
        filterId: FILTER_ZONES
    },
    {
        heading: "Master Controllers",
        accessor: "controller",
        isNumeric: false,
        id: 2,
        sortByName: "zoneByZoneId.controller.deviceImprox.devName",
        sortDirection: "asc",
        active: true,
        searchOnName: "zoneByZoneId.controller.deviceImprox.id",
        lookupName: "zoneByZoneId.controller.deviceImprox.devName",
        translationKey: "masterController",
        columnId: COLUMN_CONTROLLER,
        settingDataName: "deviceImprox",
        filterId: FILTER_CONTROLLER
    },
    {
        heading: "Site",
        accessor: "site",
        isNumeric: false,
        id: 3,
        sortByName: "zoneByZoneId.controller.site.siteName",
        sortDirection: "asc",
        active: true,
        searchOnName: "zoneByZoneId.controller.deviceImprox.site.id",
        lookupName: "zoneByZoneId.controller.deviceImprox.site.siteName",
        translationKey: "site",
        columnId: COLUMN_SITE,
        settingDataName: "site",
        filterId: FILTER_SITES
    },
    {
        heading: "Entry Reader",
        accessor: "entryReader",
        isNumeric: false,
        id: 4,
        active: true,
        translationKey: "entryReader",
        columnId: COLUMN_ENTRY_READER,
    },
    {
        heading: "Exit Reader",
        accessor: "exitReader",
        id: 5,
        isNumeric: false,
        active: true,
        translationKey: "exitReader",
        columnId: COLUMN_EXIT_READER,
    }
];

export default DoorColumns;
